import React, { useState, useEffect } from 'react';
import { userService } from '../api/userService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import SearchBar from '../components/Common/SearchBar';
import UserForm from '../components/Users/UserForm';
import '../components/Common/Common.css';

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const params = { page: currentPage, search: searchTerm, per_page: 15 };
      if (roleFilter) params.role = roleFilter;

      const response = await userService.getUsers(params);
      setUsers(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [currentPage, searchTerm, roleFilter]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.')) {
      try {
        await userService.deleteUser(id);
        fetchUsers();
      } catch (error) {
        console.error('Error deleting user:', error);
        alert('Échec de la suppression de l\'utilisateur');
      }
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingUser(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingUser(null);
    fetchUsers();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'username', label: 'Nom d\'utilisateur' },
    { key: 'name', label: 'Nom complet' },
    { key: 'email', label: 'Email' },
    {
      key: 'role',
      label: 'Rôle',
      render: (val) => <span className={`badge ${val === 'admin' ? 'badge-danger' : 'badge-info'}`}>{val === 'admin' ? 'Admin' : 'Utilisateur'}</span>
    },
    { key: 'created_at', label: 'Créé le', render: (val) => new Date(val).toLocaleDateString() },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Utilisateurs</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter un utilisateur
        </button>
      </div>

      <div className="filters">
        <div className="filters-grid">
          <div style={{ gridColumn: 'span 2' }}>
            <SearchBar
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Rechercher des utilisateurs par nom, nom d'utilisateur ou email..."
              onClear={() => setCurrentPage(1)}
            />
          </div>
          <div className="form-group">
            <label>Filtrer par rôle</label>
            <select
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
            >
              <option value="">Tous les rôles</option>
              <option value="admin">Admin</option>
              <option value="user">Utilisateur</option>
            </select>
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={users}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editingUser ? 'Modifier l\'utilisateur' : 'Créer un utilisateur'}
      >
        <UserForm
          user={editingUser}
          onSuccess={handleFormSuccess}
          onCancel={() => setShowModal(false)}
        />
      </Modal>
    </div>
  );
}

export default Users;
